import { FC } from 'react';
import { ZendeskUser } from '../../@types/Zendesk';
import { Stack, Typography } from '@mui/material';
import { User } from '../../@types/Auth';

interface ZendeskBadgeProps { zendeskUser: ZendeskUser | undefined, user: User | undefined }

const ZendeskBadge: FC<ZendeskBadgeProps> = ({ zendeskUser, user }) => {

  const madjaxZendeskUser = zendeskUser?.email?.includes('@nivel.com');

  return (

    <Stack

      display="flex"

      flexDirection="row"

      alignItems="center"

      justifyContent="center">

      {madjaxZendeskUser &&

        <Typography

          sx={(theme) => ({

            backgroundColor: theme.colors.primary,

            padding: '8px',

            fontWeight: 'bold',

            letterSpacing: '1.4px',

            color: 'white',

            fontSize: '10px',

            textTransform: 'uppercase',

          })}>

            MadJax Team

        </Typography>

      }

      <Typography sx={{ marginLeft: '8px' }}>

        {zendeskUser?.name ?? zendeskUser?.email}

      </Typography>

    </Stack>
  );


}
export default ZendeskBadge;
